import React from 'react'
import PropTypes from 'prop-types';

import './Card.css';
import AdditionalCard from '../../Common/AdditionalPlanCards/AdditionalCard';

const CardC = (props) => {

  return (

    <React.Fragment>

    <div className={`fixedline-sales-card-container ${props.className}`}
      automationid={`SalesLead_Div_${props.automationidattr}Card_${props.automationIndex ? props.automationIndex : 0}`}>
      {props && props.children}
    </div>

    { props?.vasCategory === 'LTE' && props.currentToggleState ?

      <div className='LTE_PlansWrapper'>

        <p className="service-title"
          automationid=''>Which LTE package would you like?
        </p>

        <p className="service-description"
          automationid="">
            While waiting for the fibre installation, you&apos;ll enjoy FREE LTE for a whole month! After the first month, you can stay connected on your preferred LTE plan below. 
            Once fibre is up and running, the LTE service will stop and you&apos;ll pay for the fibre line instead.
        </p>

        <div className='cards_wrapper'>

          { props.servicePlans.map(service =>

                <AdditionalCard 
                  size={service.size}
                  price={service.price.displayValue}
                  parameterId={service.actions[0].parameters[0].parameterId}
                  handleOnSelect={service}
                  offeringID={props.offeringID}
                  actionId={service.actions[0].actionId}
                  category={props?.vasCategory}
                  key={service.actions[0].parameters[0].parameterId}
                />
              )
          }

        </div>
      </div>
      :
      null
    }

    </React.Fragment>
  );
}

CardC.propTypes = {
  automationidattr: PropTypes.string,
  automationIndex: PropTypes.number,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  isLteToggle: PropTypes.bool,
  currentToggleState: PropTypes.bool,
  vasCategory: PropTypes.string,
  servicePlans: PropTypes.array,
  parameterId: PropTypes.string,
  offeringID: PropTypes.string
}

export const Card = CardC;